export enum SolidSurfaceConfigCornerRadius {
    SOFT = 'soft',
    RADIUS = 'radius',
    CURVED = 'curve',
    INTERNAL = 'internal',
    ANGLED = 'angle'
}
